<svg width="40" height="40" viewBox="10 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M25 32L13 20L25 8" stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
